var isNull = function isNull(value) {
  return value === null;
};

module.exports = isNull;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/type/is-null.js
// module id = 236
// module chunks = 0